import { z } from 'zod';
import { PartnerBadgeSchema } from './badge';

/**
 * Schema for expert quick search result item
 */
export const ExpertQuickSearchResultSchema = z.object({
    id: z.number().int().positive(),
    name: z.string().min(1),
    email: z.string().email().nullable(),
    avatar: z.string().url().nullable(),
    badges: z.array(PartnerBadgeSchema),
});

/**
 * Type for expert quick search result
 */
export type ExpertQuickSearchResult = z.infer<typeof ExpertQuickSearchResultSchema>;

